function InlineVideo() {
	const videoContainer = document.querySelector('.c-inline-video-row');

	// Bail if component does not exist
	if( !videoContainer ) return;

	const video = videoContainer.querySelector('.c-inline-video-row_video'),
				play  = videoContainer.querySelector('.c-inline-video-row_container');

	video.addEventListener('click', function() {
		videoContainer.classList.add('is-paused');
		video.pause();
	});

	play.addEventListener('click', function() {
		videoContainer.classList.remove('is-paused');
		video.play();
	});
}

export { InlineVideo }